import TextField from '@mui/material/TextField'

export default function Input({ children, size, center, right, hideLabel, disabled, onChange, error, helperText, variant, onEnter, onKeyDown, number, monthYear, formSelect, multiple, hideHelperText, ...props }) {
  const [prevValue, setPrevValue] = useState('')
  const t = useI18n()
  size ||= 'small'

  onKeyDown ||= event => {
    if (event.code === 'Enter') {
      onEnter && onEnter()
      return
    }
  }

  const { current } = useLoading()
  disabled = !!(disabled || current)
  const renderHelperText = () => {
    if (hideHelperText) return
    const helperTextWrapper = () => {
      if (!error) return helperText
      if (!Array.isArray(error)) return helperText
      const [key, params] = error
      return t(`error:${key}`, params)
    }
    return helperTextWrapper() || ' '
  }
  return (
    <>
      <TextField
        variant={ variant }
        className={ cn(`utils-input-root ${variant}`,
          { 'input-label-center': center },
          { 'input-label-right': right },
          { 'input-label-hide': hideLabel },
          { 'border-b cursor-pointer border-gray-400 hover:border-black hover:border-b-2': formSelect },
          { 'input-padding-right': multiple }
        ) }
        size={ size }
        onChange={ event => {
          if (!onChange) return
          if (monthYear) return onChange(parseMonthYear(event.target.value, prevValue, setPrevValue))
          if (number) return onChange(parseNumber(event.target.value))
          onChange(event.target.value)
        } }
        disabled={ disabled }
        onKeyDown={ onKeyDown }
        error={ !!error }
        helperText={ renderHelperText() }
        { ...props }
      >
        {children}
      </TextField>
      <style global jsx>{`
        .utils-input-root {
          .MuiFormHelperText-root {
            text-align: right;
            opacity: 0.5;
          }
        }

        .input-padding-right {
          textarea {
            padding-right: 1.5rem
          }
        }

        .input-label-right {
          input {
            text-align: right;
          }
        }

        .input-label-center {
          input {
            text-align: center;
          }

          label {
            padding: 0 7px;
            transform-origin: center;
            font-size: 0.9rem;
            left: 50%;
            background: white;
            transform: translate(-50%, 9px) scale(1);

            &.Mui-focused,
            &.MuiFormLabel-filled {
              transform: translate(-50%, -9px) scale(0.75);
            }
          }

          legend {
            width: 0
          }
        }

        .input-label-center.standard {
          label {
            transform: translate(-50%, 19px) scale(1);

            &.Mui-focused,
            &.MuiFormLabel-filled {
              transform: translate(-50%, -9px) scale(0.75);
            }
          }
        }
        .input-label-hide {
          label {
            visibility: hidden;
          }
        }
      `}</style>
    </>
  )
}

const parseMonthYear = (value, prevValue, setPrevValue) => {
  const prevValueLen = prevValue.length
  setPrevValue(value)
  if (!value.toNumber() || value.trim().length !== 2 || prevValueLen !== 1) return value
  return `${value}/`
}

const parseNumber = value => {
  const lastChar = value.charAt(value.length - 1)
  const escapeChars = ['-', '+', '.']
  if (escapeChars.includes(lastChar)) return value
  return parseFloat(value) || 0
}